import { useFormContext } from "react-hook-form";
import { ErrorMessage, TextInput, Typography } from "@/components/atoms";
import { clsx, getCurrencySymbol } from "@/utils";
import { SignUpOperatorFormData } from "../types";
import { useOperator } from "@/hooks";

export const AverageTripCostField = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
  const { currency } = useOperator()
  const {
    register,
    formState: { errors },
  } = useFormContext<SignUpOperatorFormData>();

  return (
    <div className={clsx("flex flex-row items-center gap-x-2", className)} {...props}>
      <div className="flex flex-col w-full">
        <Typography variant="paragraph">Average Trip Cost</Typography>
        <Typography variant="small" className="text-neutral-dark-gray">Best guestimate is sufficient. Enter amount in AUD ($).</Typography>
        <ErrorMessage errors={errors} name="averageTripCost" />
      </div>
      <TextInput
        className="flex-1 w-[72px]"
        type="number"
        placeholder={`${getCurrencySymbol(currency)}0`}
        step="any"
        hasError={!!errors.averageTripCost}
        {...register("averageTripCost")}
      />
    </div>
  );
};
